import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const fetchVesselCostCentreQuery = (data) => {
  const cleanedData = removeEmpty(data);
  return axios.post(apiurl?.getVesselCostCentreList, cleanedData);
};

const fetchVesselCostCentres = (data) => {
  return useQuery(
    ['getvesselcostcenterlist', data],
    () => fetchVesselCostCentreQuery(data),
    { refetchOnWindowFocus: false }
  );
};

export default fetchVesselCostCentres;
